(function () {
  function getVariantData(root) {
    if (root.__productVariants) return root.__productVariants;

    var script = root.querySelector('[data-product-variants]');
    if (!script) return [];

    try {
      root.__productVariants = JSON.parse(script.textContent || '[]');
    } catch (error) {
      console.error('Produktvarianten konnten nicht gelesen werden.', error);
      root.__productVariants = [];
    }

    return root.__productVariants;
  }

  function findVariant(root, variantId) {
    var variants = getVariantData(root);
    var id = String(variantId || '');

    return variants.find(function (variant) {
      return String(variant.id) === id;
    }) || null;
  }

  function updatePrice(root, variant) {
    var price = root.querySelector('[data-variant-price]');
    var comparePrice = root.querySelector('[data-variant-compare-price]');

    if (price && variant.price) {
      price.textContent = variant.price;
    }

    if (comparePrice) {
      if (variant.compare_at_price) {
        comparePrice.textContent = variant.compare_at_price;
        comparePrice.hidden = false;
      } else {
        comparePrice.textContent = '';
        comparePrice.hidden = true;
      }
    }
  }

  function updateAvailability(root, variant) {
    var availability = root.querySelector('[data-variant-availability]');
    var availabilityText = root.querySelector('[data-variant-availability-text]');
    var submit = root.querySelector('[data-variant-submit]');

    if (availability) {
      availability.classList.toggle('is-unavailable', !variant.available);
    }

    if (availabilityText) {
      availabilityText.textContent = variant.available
        ? 'Auf Lager und direkt bestellbar'
        : 'Aktuell ausverkauft';
    }

    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    }
  }

  function updateVariantMedia(root, variant) {
    if (!variant.featured_media_id) return;

    var gallery = root.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var thumb = gallery.querySelector('[data-product-gallery-thumb][data-media-id="' + variant.featured_media_id + '"]');
    if (thumb && !thumb.classList.contains('is-active')) {
      thumb.click();
    }
  }

  function updateUrl(variant) {
    if (!window.history || !window.history.replaceState) return;

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      // Bei sehr alten Browsern bleibt die aktuelle URL unverändert.
    }
  }

  function applyVariant(root, variant, updateBrowserUrl) {
    if (!root || !variant) return;

    updatePrice(root, variant);
    updateAvailability(root, variant);
    updateVariantMedia(root, variant);

    if (updateBrowserUrl) {
      updateUrl(variant);
    }

    root.dispatchEvent(new CustomEvent('product:variant-change', {
      bubbles: true,
      detail: { variant: variant }
    }));
  }

  function initializeRoot(root) {
    if (!root) return;

    var select = root.querySelector('#VariantSelect');
    if (!select) return;

    applyVariant(root, findVariant(root, select.value), false);
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('#VariantSelect');
    if (!select) return;

    var root = select.closest('[data-product-variant-root]');
    if (!root) return;

    applyVariant(root, findVariant(root, select.value), true);
  });

  document.querySelectorAll('[data-product-variant-root]').forEach(initializeRoot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.matches && event.target.matches('[data-product-variant-root]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-product-variant-root]');

    initializeRoot(root);
  });
})();
